import { Routes } from '@angular/router';
import { UnsavedChangesGuard } from '../@core/guards/unsaved-changes.guard';
import { adsVideosSettingsChildRoutes } from '../features/ads/ads-videos/ads-videos-settings-child-routes.routes';
import { adsCampaignsSettingsChildRoutes } from '../features/ads/campaigns/ads-campaigns-settings-child-routes.routes';
import { mediaSettingsChildRoutes } from '../features/media-page/media-settings-child-routes.routes';
import { appRoutes } from '../shared/constants/routes.constants';

export const applicationChildRoutes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    redirectTo: appRoutes.EDITOR,
  },
  {
    path: appRoutes.DASHBOARD,
    loadComponent: () => import('../features/dashboard/dashboard.component').then((m) => m.DashboardComponent),
  },
  {
    path: appRoutes.EDITOR,
    loadComponent: () =>
      import('../features/editor-navigator-page/editor-navigator-page.component').then((m) => m.EditorNavigatorPageComponent),
    canDeactivate: [UnsavedChangesGuard],
  },
  {
    path: appRoutes.MEDIA,
    children: [
      {
        path: '',
        redirectTo: appRoutes.VIDEOS,
        pathMatch: 'full',
      },
      {
        path: appRoutes.VIDEOS,
        loadComponent: () => import('../features/media-page/media-page.component').then((m) => m.MediaPageComponent),
      },
      {
        path: appRoutes.PODCASTS,
        loadComponent: () => import('../features/media-page/media-page.component').then((m) => m.MediaPageComponent),
      },
      {
        path: `${appRoutes.VIDEOS}/:id`,
        loadComponent: () =>
          import('../layout/media-settings-layout/media-settings-layout.component').then((m) => m.MediaSettingsLayoutComponent),
        children: mediaSettingsChildRoutes,
      },
      {
        path: `${appRoutes.PODCASTS}/:id`,
        loadComponent: () =>
          import('../layout/media-settings-layout/media-settings-layout.component').then((m) => m.MediaSettingsLayoutComponent),
        children: mediaSettingsChildRoutes,
      },
    ],
  },
  {
    path: appRoutes.ADS,
    children: [
      {
        path: '',
        redirectTo: appRoutes.VIDEOS,
        pathMatch: 'full',
      },
      {
        path: appRoutes.VIDEOS,
        loadComponent: () => import('../features/ads/ads-videos//ads-videos.component').then((m) => m.AdsVideosComponent),
      },
      {
        path: `${appRoutes.VIDEOS}/:id`,
        loadComponent: () =>
          import('../layout/ads-settings-layout/ads-settings-layout.component').then((m) => m.AdsSettingsLayoutComponent),
        children: adsVideosSettingsChildRoutes,
      },
      {
        path: appRoutes.CAMPAIGNS,
        loadComponent: () => import('../features/ads/campaigns/campaigns.component').then((m) => m.CampaignsComponent),
      },
      {
        path: `${appRoutes.CAMPAIGNS}/:id`,
        loadComponent: () =>
          import('../layout/ads-settings-layout/ads-settings-layout.component').then((m) => m.AdsSettingsLayoutComponent),
        children: adsCampaignsSettingsChildRoutes,
      },
    ],
  },
  {
    path: appRoutes.EDITOR_PREVIEW,
    loadComponent: () => import('../features/editor-preview/editor-preview.component').then((m) => m.EditorPreviewComponent),
  },
];
